import * as Yup from "yup";


export const ReportsSchedularSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  scheduleType: Yup.string().required("Schedule type is required"),
  selectedDays: Yup.object()
    .test(
      "at-least-one-selected",
      "At least one day must be selected",
      (value) => Object.values(value).includes(true)
    )
    .required("At least one day must be selected"),
  type: Yup.string().required("Report type is required"),
  selectedFunds: Yup.array()
    .min(1, "At least one fund must be selected")
    .required("At least one fund must be selected"),
});
